import turfDistance from '@turf/distance';
import { lineString } from '@turf/helpers';
import turfLength from '@turf/length';
import { milesToMeters } from '@alltrails/data-formatting/distanceConverters';
import { CustomRouteSegment } from '../../../types/CustomRoute';
import { LatLng } from '../../../types/Geo';

const MAX_PATH_LENGTH_MILES = 500;
const MAX_POINT_DISTANCE_MILES = 100;

// Validate path length
export const validatePathLength = (newPoints: LatLng[]): boolean => {
  const maxPathLengthMeters = milesToMeters(MAX_PATH_LENGTH_MILES);

  const geoJsonCoords = newPoints.map(point => [point[1], point[0]]);
  const line = lineString(geoJsonCoords);
  const pathLengthMeters = turfLength(line, { units: 'meters' });

  return pathLengthMeters <= maxPathLengthMeters;
};

// Validate proximity to previous point
export const validateProximityToPreviousPoint = (newPoint: LatLng, prevPoint: LatLng): boolean => {
  const maxPointDistanceMeters = milesToMeters(MAX_POINT_DISTANCE_MILES);

  return turfDistance([prevPoint[1], prevPoint[0]], [newPoint[1], newPoint[0]], { units: 'meters' }) <= maxPointDistanceMeters;
};

// Utility to get the point for a handle in a segment
export function getPointForHandle(segment: CustomRouteSegment, handleIndex: number | undefined): [number, number] | undefined {
  if (!segment || segment.paths.length === 0 || handleIndex === undefined) {
    return undefined;
  }

  const isEnd = handleIndex === segment.paths.length;
  const pathIndex = isEnd ? segment.paths.length - 1 : handleIndex;
  const path = segment.paths[pathIndex];

  if (!path || path.points.length === 0) {
    return undefined;
  }

  const pointIndex = isEnd ? path.points.length - 1 : 0;
  return path.points[pointIndex];
}
